<template>
  <div>
    <HeaderPage>
      <div class="container mt-4">
        <h2>Catégories</h2>
        <!-- Bouton pour ouvrir la modal de création de catégorie -->
        <button class="btn btn-primary mb-3 create-article-btn" @click="openCategoryModal">
          <i class="fas fa-plus"></i> Créer une catégorie
        </button>

        <!-- Barre de recherche -->
        <div class="text-center mb-3">
          <input
            type="text"
            v-model="searchTerm"
            placeholder="Rechercher par nom"
            class="form-control"
            style="max-width: 300px; display: inline-block;"
          />
        </div>

        <!-- Tableau des catégories -->
        <div class="table-responsive mt-4">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Nom de la catégorie</th>
                <th>Code de la catégorie</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="categorie in filteredCategories" :key="categorie.id">
                <td>{{ categorie.nom_categorie }}</td>
                <td>{{ categorie.code_categorie }}</td>
                <td>
                  <!-- Bouton pour supprimer la catégorie -->
                  <a href="#" @click.prevent="deleteCategory(categorie)" class="delete-btn">
                    <i class="fas fa-trash"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Modal de création de catégorie -->
      <div v-if="showCategoryModal">
        <div
          class="modal fade"
          id="categoryModal"
          tabindex="-1"
          aria-labelledby="categoryModalLabel"
          aria-hidden="true"
          ref="categoryModalRef"
        >
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="categoryModalLabel">Créer une Catégorie</h5>
                <button type="button" class="btn-close" @click="closeCategoryModal"></button>
              </div>
              <div class="modal-body">
                <form @submit.prevent="submitCategory">
                  <div class="form-group mb-3">
                    <input
                      type="text"
                      v-model="newCategory.nom_categorie"
                      class="form-control"
                      placeholder="Nom"
                      required
                    />
                  </div>
                  <div class="form-group mb-3">
                    <input
                      type="text"
                      v-model="newCategory.code_categorie"
                      class="form-control"
                      placeholder="Code"
                      required
                    />
                  </div>
                  <button type="submit" class="btn btn-success w-100">
                    Ajouter
                  </button>
                </form>
                <p v-if="successMessage" class="success-message mt-2">{{ successMessage }}</p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-danger" @click="closeCategoryModal">
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </HeaderPage>
  </div>
</template>

<script>
import HeaderPage from './components/HeaderPage.vue';
import axios from "axios";
import * as bootstrap from "bootstrap";
import { nextTick } from "vue";

export default {
  name: "CategoriesDisplay",
  components: {
    HeaderPage,
  },
  data() {
    return {
      newCategory: {
        nom_categorie: "",
        code_categorie: "",
      },
      categories: [],
      successMessage: "",
      showCategoryModal: false,
      categoryModalInstance: null,
      searchTerm: "",
    };
  },
  computed: {
    filteredCategories() {
      if (!this.searchTerm) {
        return this.categories;
      }
      return this.categories.filter(categorie =>
        categorie.nom_categorie.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    },
  },
  mounted() {
    this.getCategories();
  },
  methods: {
    getCategories() {
      const API_URL = process.env.VUE_APP_API_URL;
      axios
        .get(`${API_URL}/api/categories`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}`,
          Accept: "application/json",
           }
        })
        .then((response) => {
          this.categories = response.data;
        })
        .catch((error) => {
          console.error("Erreur lors de la récupération des catégories :", error);
        });
    },
    openCategoryModal() {
      this.showCategoryModal = true;
      nextTick(() => {
        const modalElement = this.$refs.categoryModalRef;
        if (modalElement) {
          this.categoryModalInstance = new bootstrap.Modal(modalElement);
          this.categoryModalInstance.show();
        } else {
          console.error("Le modal n'a pas été trouvé.");
        }
      });
    },
    closeCategoryModal() {
      if (this.categoryModalInstance) {
        this.categoryModalInstance.hide();
      }
      this.showCategoryModal = false;
      this.resetCategoryForm();
    },
    submitCategory() {
      if (!this.newCategory.nom_categorie || !this.newCategory.code_categorie) {
        alert("Veuillez remplir tous les champs");
        return;
      }

      const token = localStorage.getItem("token");
      const API_URL = process.env.VUE_APP_API_URL;
      axios
        .post(`${API_URL}/api/categoriesInsert`, {
          nom_categorie: this.newCategory.nom_categorie,
          code_categorie: this.newCategory.code_categorie,
        }, {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then((response) => {
          this.successMessage = response.data.message;
          this.getCategories(); // Actualiser le tableau après ajout
          // Fermer la modal après un court délai
          setTimeout(() => {
            this.closeCategoryModal();
            this.successMessage = "";
          }, 1500);
        })
        .catch((error) => {
          console.error("Erreur lors de l'ajout de la catégorie :", error);
          alert("Une erreur est survenue lors de l'ajout de la catégorie.");
        });
    },
    resetCategoryForm() {
      this.newCategory.nom_categorie = "";
      this.newCategory.code_categorie = "";
    },
    deleteCategory(categorie) {
      if (!confirm("Êtes-vous sûr de vouloir supprimer cette catégorie ?")) {
        return;
      }
      const token = localStorage.getItem("token");
      const API_URL = process.env.VUE_APP_API_URL;
      axios
        .delete(`${API_URL}/api/api/categoriesDelete/${categorie.id}`, {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then((response) => {
          alert(response.data.message);
          this.getCategories();
        })
        .catch((error) => {
          console.error("Erreur lors de la suppression de la catégorie :", error);
          alert("Une erreur est survenue lors de la suppression de la catégorie.");
        });
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.create-article-btn {
  width: 250px; /* Ajustez la valeur selon vos besoins */
}

.btn-primary {
  background-color: #007bff;
  border: none;
}

.table-responsive {
  width: 100%;
  max-width: 800px;
  margin-top: 20px;
}

.modal-content {
  border-radius: 8px;
  padding: 15px;
}

.success-message {
  color: #28a745;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}
</style>
